import config from "../config";
import { apiUrl, getWithJsonHeader, postJson } from "./apiClient";

/**
 * Dashboard, report and smart-table endpoints of the main claims database.
 *
 * Each function resolves to the fetch Response, unchanged, so a component keeps
 * its own status checks, error messages and response parsing. Only the request
 * itself (path, method, headers, body) lives here.
 */

/** POST /generate-claim-data/ - monthly totals and forecast for one year (Claims Trend Analysis). */
export const fetchClaimTrend = (year) => postJson("/generate-claim-data/", { year });

/** POST /claim-status-distribution/ - accepted / rejected / pending counts for one year. */
export const fetchClaimStatusDistribution = (year) => postJson("/claim-status-distribution/", { year });

/** GET /rejected-claims-by-reason/?year= - rejected claims grouped by reason code. */
export const fetchRejectedClaimsByReason = (year) => getWithJsonHeader(`/rejected-claims-by-reason/?year=${year}`);

/** GET /forecast-claims/ - daily actual and predicted claims per model (dashboard key). */
export const fetchClaimForecast = () => fetch(apiUrl("/forecast-claims/"));

/** GET /last-month-claims/ - the claims table. Rejects when no API URL is configured. */
export const fetchLastMonthClaims = async () => {
  if (!config.API_BASE_URL) throw new Error("No API URL");
  return fetch(apiUrl("/last-month-claims/"));
};

/** POST /ai-data-card/ - the AI insight for one status code. */
export const fetchAiDataCard = (statusCode) => postJson("/ai-data-card/", { status_code: statusCode });

/** POST /ai-data-provider/ - chart data generated from a natural-language prompt. */
export const fetchAiChartData = (prompt) => postJson("/ai-data-provider/", { prompt });

/** POST /ai-smart-table/ - table rows generated from a natural-language query. */
export const fetchAiSmartTable = (prompt) => postJson("/ai-smart-table/", { prompt });
